<template>
	<div class="paging">
		<nav-link :click="() => handleClick(firstPage)">
			<font-awesome-icon icon="chevron-left" />
		</nav-link>
		<nav-link
			:click="() => handleClick(item + pagingBlock)"
			v-for="item in listPageBlock"
			v-bind:key="item"
			:class="item + pagingBlock === page ? 'active' : ''"
			>{{ item + pagingBlock }}
		</nav-link>
		<nav-link :click="() => handleClick(lastPage)">
			<font-awesome-icon icon="chevron-right" />
		</nav-link>
	</div>
</template>

<script>
export default {
	name: 'Paging',
	props: {
		totalCount: {
			type: Number,
		},
		page: {
			type: Number,
		},
		rows: {
			type: Number,
		},
		click: {},
	},
	data: function() {
		return {
			blockSize: 10,
		};
	},
	computed: {
		totalPage: function() {
			return Math.ceil(this.totalCount / this.rows);
		},
		pagingBlock: function() {
			return (Math.ceil(this.page / this.blockSize) - 1) * this.blockSize;
		},
		firstPage: function() {
			return this.pagingBlock < 1 ? 1 : this.pagingBlock;
		},
		lastPage: function() {
			return Math.min(this.pagingBlock + this.blockSize + 1, this.totalPage);
		},
		listPageBlock: function() {
			let maxPage = this.pagingBlock + this.blockSize > this.totalPage ? this.totalPage - this.pagingBlock : this.blockSize;
			return maxPage < 1 ? 1 : maxPage;
		},
	},
	methods: {
		handleClick: function(p) {
			if (this.totalCount > 0) {
				if (this.click) {
					this.click(p);
				}
			}
		},
	},
};
</script>

<style scoped></style>
